if (!window.scrollTo) {
  window.scrollTo = function scrollTo(x, y) {
    window.pageXOffset = x;
    window.pageYOffset = y;
  };
}

if (!document.body.scrollTo) {
  Element.prototype.scrollTo = function scrollTo(x, y) {
    this.scrollLeft = x;
    this.scrollTop = y;
  };
}
